import {
  gql,
  OperationVariables,
  QueryHookOptions,
  useQuery,
} from '@apollo/client';

import { IGetEntityEdrStatus } from './types';

export const GET_ENTITY_EDR_STATUS = gql`
  query getEntityEdrStatus($entity_id: String!, $tenant: String) {
    getEntityEdrStatus(entity_id: $entity_id, tenant: $tenant) {
      tenant
      entity_edr_status
      updated_timestamp
    }
  }
`;

export const useGetEntityEdrStatus = (
  options: QueryHookOptions<IGetEntityEdrStatus, OperationVariables>,
) => useQuery<IGetEntityEdrStatus>(GET_ENTITY_EDR_STATUS, options);
